import { render, staticRenderFns } from "./CampaignFieldsCard.vue?vue&type=template&id=5bfd066e"
import script from "./CampaignFieldsCard.vue?vue&type=script&lang=js"
export * from "./CampaignFieldsCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignFieldsCard.vue?vue&type=style&index=0&id=5bfd066e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports